import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgAirzoneInstall extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 80.18 80.2">
                <polygon points="39.61 20.93 31.3 43.61 48.47 43.61 39.62 20.93 39.61 20.93" fill={color} />
                <path
                    d="M40.07,0a40.1,40.1,0,0,0,0,80.2v0A40.09,40.09,0,1,0,40.07,0ZM55.62,63.41,49.79,47.26H30L24.16,63.42H19.34L34.8,21.09a32.12,32.12,0,0,0,1.34-4.64c0-3.1-2.89-3.18-6-3.65V11.09h14.6l19,52.32Z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SvgAirzoneInstall);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgAirzoneInstall.js